import { View } from "react-native";
import Loading from "src/components/Loading";

const SearchLoading = () => {
	return (
		<View
			style={{
				flex: 1,
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<Loading />
		</View>
	);
};
export default SearchLoading;
